"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4663],{

/***/ 4663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22366);



var farms = [
    {
        pid: 2,
        v1pid: 2,
        lpSymbol: "Chewy-Bone LP",
        lpAddress: "0x324EEf33AF720cE44DEAB7e32F4367a82b4eA43b",
        boosted: false,
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .shibariumTokens.chewy */ .LM.chewy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .shibariumTokens.wbone */ .LM.wbone
    }, 
].map(function(p) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, p), {
        token: p.token.serialize,
        quoteToken: p.quoteToken.serialize
    });
});
/* harmony default export */ __webpack_exports__["default"] = (farms);


/***/ })

}]);